import {systemBaseEvent} from "../../../../base/baseEvent";

export default function convertInterview({component, record, businessIdField}) {
    if (record.taskId) {
        return {
            name: "查看任务",
            condition: ["已采用"],
            auth: "interviewTask_creator",
            onOk: ()=>{
                component.viewTasks(record)
            },
            record: record,
            taskId: record.taskId
        };
    }
    return {
        name: "转为任务", condition: ["已采用"], auth: "interviewTask_creator", onOk: () => {
            if (businessIdField) {//比如线索，我会将线索这条record的数据增加一个属性叫做 clueId, 这样将数据传到任务那边，就能实现双向绑定
                record[businessIdField] = record.id;
            }
            systemBaseEvent.asyncPlaybackExec("interviewAdd", record);
            // window.location.hash = "#/view/interview/receiverTask";
            window.location.hash = "#/view/interview/createTask";
        }
    };
}
